import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';
import { LocalAccountService } from '../shared/services/localAccount.service';

@Injectable({
    providedIn: 'root'
})
export class WebSocketService {

    private static MAX_CREATE_WEB_SOCKET_ATTEMPTS = 40;
    private socket: WebSocket;
    private socketInterval: NodeJS.Timeout;
    private currCreateWebSocketAttempts: number;
    private enqueuedWebSocketMessages: Array<any>;
    private webSocketSubject = new Subject<any>();

    // backup
    private precSocket: WebSocket;
    private precSocketInterval: NodeJS.Timeout;
    private precCurrCreateWebSocketAttempts: number;


    constructor(
        private localAccountService: LocalAccountService
    ) {
        this.currCreateWebSocketAttempts = 0;
        this.enqueuedWebSocketMessages = new Array<any>();
        // this.createWebSocket();
    }

    public publishWebSocketReceivedMessage(data: any) {
        this.webSocketSubject.next(data);
    }

    public listenOnWebSocketReceivedMessages(): Subject<any> {
        return this.webSocketSubject;
    }

    public closeSocket() {
        this.stopSocketHeartbit();
        if (this.socket) {
            this.socket.close();
            this.socket = null;
            this.currCreateWebSocketAttempts = 0;
        }
    }

    public sendWebSocketMessage(event, status, data) {
        data.status = status;
        const msg = {
            event: event,
            data: data
        };
        let ok = false;
        if (this.socket) {
            if (this.socket.readyState === this.socket.OPEN) {
                if (this.enqueuedWebSocketMessages.length > 0) {
                    console.log('sendEnqueuedWebSocketMessages (' + this.enqueuedWebSocketMessages.length + ')');
                    this.sendEnqueuedWebSocketMessages();
                }
                this.socket.send(JSON.stringify(msg));
                ok = true;
            } else if (this.socket.readyState === this.socket.CONNECTING) {
                console.log('new message enqueued');
                console.log('Socket', this.socket);
                console.log('Message', msg);
                this.enqueuedWebSocketMessages.push(JSON.stringify(msg));
            } else if (this.socket.readyState === this.socket.CLOSING || this.socket.readyState === this.socket.CLOSED) {
                console.log('new message enqueued');
                console.log('Socket', this.socket);
                console.log('Message', msg);
                this.enqueuedWebSocketMessages.push(JSON.stringify(msg));
                this.createWebSocket();
            }
        }
        if (!ok) {
            console.log('Messaggio non inviato');
            console.log('Socket', this.socket);
            console.log('Message', msg);
        }
    }

    public createWebSocket() {
        if (!this.localAccountService.getToken()) {
            console.error('Can not create web socket for not logged user');
            return;
        }
        if (this.currCreateWebSocketAttempts < WebSocketService.MAX_CREATE_WEB_SOCKET_ATTEMPTS) {
            if (this.socket) {
                if (this.socket.readyState === this.socket.OPEN || this.socket.readyState === this.socket.CONNECTING) {
                    this.currCreateWebSocketAttempts = 0;
                    return;
                } else if (this.socket.readyState === this.socket.CLOSING || this.socket.readyState === this.socket.CLOSED) {
                    console.log('trying createWebSocket', this.socket.readyState);
                    this.currCreateWebSocketAttempts++;
                    setTimeout(() => {
                        this._createWebSocket();
                    }, 10 * 1000);
                    return;
                }
            } else {
                this._createWebSocket();
            }
        } else {
            throw new Error('Impossible to createWebSocket');
        }
    }

    private _createWebSocket() {
        console.log('createWebSocket');
        this.precSocket = this.socket;
        this.precCurrCreateWebSocketAttempts = this.currCreateWebSocketAttempts;
        this.precSocketInterval = this.socketInterval;
        try {
            // this code is asynchronous, so the try catch may have not sense
            this.socket = new WebSocket(environment.webSocketUrl + '?authtoken=' + this.localAccountService.getToken());
        } catch (ex) {
            console.error(ex);
            return;
        }
        this.socket.onopen = this.onOpenSocketCallback();
        this.socket.onmessage = this.onMessageCallback();
        this.socket.onerror = this.onErrorCallback();
        this.currCreateWebSocketAttempts = 0;
    }

    private stopSocketHeartbit() {
        if (this.socketInterval) {
            try {
                clearInterval(this.socketInterval);
                this.socketInterval = null;
            } catch (ex) {
                console.log(ex);
                this.socketInterval = null;
            }
        }
    }

    private onOpenSocketCallback(): (string) => void {
        return (message) => {
            console.log('open socket');
            this.heartbit();
            this.socketInterval = setInterval(() => {
                this.heartbit();
            }, 40 * 1000);
        };
    }

    private heartbit() {
        this.sendWebSocketMessage(
            WebSocketToSendMessages.HEARTBIT,
            WebSocketToSendMessages.HEARTBIT,
            { timestamp: new Date().getTime() });
    }

    private onMessageCallback(): (string) => void {
        return (event) => {
            try {
                console.log(event.data);
                let msg;
                try {
                    msg = JSON.parse(event.data);
                } catch (e1) {
                    msg = event.data;
                }
                console.log(msg);
                this.publishWebSocketReceivedMessage(msg);
            } catch (e) {
                console.log('Errore onMessageCallback - ', e);
            }
        };
    }

    private onErrorCallback() {
        return (event) => {
            console.log('errorHandler', event);
            if (event.type === 'error') {
                this.socket = this.precSocket;
                this.currCreateWebSocketAttempts = this.precCurrCreateWebSocketAttempts;
                this.socketInterval = this.precSocketInterval;
            }
        };
    }

    private sendEnqueuedWebSocketMessages() {
        if (this.socket.readyState === this.socket.OPEN) {
            for (let index = 0; index < this.enqueuedWebSocketMessages.length; index++) {
                const element = this.enqueuedWebSocketMessages[index];
                this.socket.send(element);
            }
            this.enqueuedWebSocketMessages = new Array<any>();
        }
    }

}

// intentionally enum not used (problem with key...toString()...)
export class WebSocketToSendMessages {
    public static HEARTBIT = 'HEARTBIT';
    public static EMPTY = '';
}
